import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const customBookingFormFieldEntity: Entity = {
  model: model,
  repository: repository,
}

export default customBookingFormFieldEntity
